import { ShieldCheck, MessageCircle } from "lucide-react";

export default function Login() {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-6">
      <div className="w-full max-w-md animate-fade-up" data-testid="login-page">
        <div className="flex items-center gap-3 mb-10">
          <div className="h-10 w-10 rounded-lg bg-emerald-500 grid place-items-center">
            <MessageCircle className="h-5 w-5 text-ink" />
          </div>
          <div>
            <p className="font-display text-lg font-semibold text-white leading-none">Diffusion</p>
            <p className="text-xs text-gray-500 mono mt-1">WHATSAPP CAMPAIGN OPS</p>
          </div>
        </div>

        <h1 className="text-4xl sm:text-5xl font-semibold text-white leading-[1.05]">
          Campagnes WhatsApp<br />
          <span className="text-emerald-400">sous contrôle.</span>
        </h1>
        <p className="mt-5 text-sm text-gray-400 leading-relaxed">
          Diffusion multi-instances avec protection du rythme d'envoi, préchauffage
          automatique et respect des fenêtres locales. Contacts opt-in uniquement.
        </p>

        <button
          data-testid="google-login-btn"
          onClick={signIn}
          className="mt-10 w-full rounded-lg bg-emerald-500 px-5 py-3.5 text-sm font-medium text-ink hover:bg-emerald-400 hover:-translate-y-[1px] active:scale-[0.99] transition-transform duration-200 flex items-center justify-center gap-3"
        >
          <svg className="h-4 w-4" viewBox="0 0 48 48" aria-hidden>
            <path fill="#0F1F1A" d="M44.5 20H24v8.5h11.8C34.7 33.9 30 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.3 0 6.3 1.2 8.6 3.3l6-6C34.6 4.9 29.6 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c11 0 20.5-8 20.5-21 0-1.4-.2-2.7-.5-4z" />
          </svg>
          Continuer avec Google
        </button>

        <div className="mt-6 flex items-start gap-2.5 rounded-lg border border-white/10 bg-white/[0.03] p-4">
          <ShieldCheck className="h-4 w-4 text-emerald-400 mt-0.5 shrink-0" />
          <p className="text-xs text-gray-400 leading-relaxed">
            Accès réservé aux administrateurs autorisés. Votre adresse Google doit figurer
            dans la liste des administrateurs pour ouvrir une session.
          </p>
        </div>
      </div>
    </div>
  );
}
